import { useState, useCallback } from 'react';

export type PaywallType = 'voice' | 'chat' | 'situation';

interface PaywallModalState {
  isOpen: boolean;
  type: PaywallType;
  used?: number;
  limit?: number;
}

export function usePaywall() {
  const [modalState, setModalState] = useState<PaywallModalState>({
    isOpen: false,
    type: 'voice',
  });

  const showPaywall = useCallback((type: PaywallType, used?: number, limit?: number) => {
    setModalState({
      isOpen: true,
      type,
      used,
      limit,
    });
  }, []);

  const hidePaywall = useCallback(() => {
    setModalState((prev) => ({
      ...prev,
      isOpen: false,
    }));
  }, []);

  return {
    modalState,
    showPaywall,
    hidePaywall,
    isOpen: modalState.isOpen,
  };
}
